<template>
    <!-- <div class="col-md-12">
            
            <nav class="navbar brb" role="navigation">
            <div class="navbar-header">
                <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-ex1-collapse">
                    <span class="sr-only">Toggle navigation</span>
                    <span class="icon-reorder"></span>                            
                </button>                                                
                <a class="navbar-brand" v-on:click="OnClickDashboard">
                 <img src="@/assets/img/LogoPiccolo.png" style="cursor:pointer" />
                </a>
                <a class="navbar-header" style="margin-top:12px; font:sans-serif; font-size:15px">Stai visualizzando il file: {{Allegato.DESCRIZIONE}}</a>                                                                                    
            </div>
            <form class="navbar-form navbar-right" >
                
                <span v-on:click="OnClickStoricoVersione" style="margin-right:20px;margin-top:30px; cursor:pointer"><span v-on:click="OnClickStoricoVersione" style="margin-top:20x; font-size:17px; cursor:pointer" class="icon-info-sign"></span> Versione Taurus 1.0.0 </span>
                                  
            </form>   
        </nav>                

    </div>   -->
     <iframe :src="BodyPDF" :height="HeightPDF" style="border:none; overflow:hidden;  width:100%"></iframe>

</template>

<script>


export default 
{
    name:'IframeStampe',
    data() 
    {
      return {
               BodyPDF : '',
               HeightPDF : '100px'
             }
    },

    methods :
    {
        SetDimensions() 
        {
          this.HeightPDF = window.innerHeight;
        }
    },

    mounted() 
    {
       window.addEventListener('resize', this.SetDimensions);
    },
    unmounted() 
    {
       window.removeEventListener('resize', this.SetDimensions);
    },
    
    beforeMount()
    {
       this.BodyPDF = window.BodyPDF;
       this.SetDimensions();
    }
}

    
</script>